import { render, staticRenderFns } from "./FileField.vue?vue&type=template&id=89681cba&scoped=true&"
import script from "./FileField.vue?vue&type=script&lang=js&"
export * from "./FileField.vue?vue&type=script&lang=js&"
import style0 from "./FileField.vue?vue&type=style&index=0&id=89681cba&prod&scoped=true&lang=css&"
import style1 from "./FileField.vue?vue&type=style&index=1&id=89681cba&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89681cba",
  null
  
)

export default component.exports